import { NgModule } from "@angular/core";
import { PreviewHtmlComponent } from "./preview-html.component";
import { CommonModule } from "@angular/common";
import { WsTooltipModule } from "@web/util/ws-ui/ws-tooltip/ws-tooltip.module";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";


@NgModule({
  imports: [
    CommonModule,
    WsTooltipModule,
    MatCardModule,
    MatIconModule,
    TranslateModule,
    WsUiModule
  ],
  declarations: [PreviewHtmlComponent],
  exports: [PreviewHtmlComponent]
})
export class PreviewHtmlModule { }